import { useTranslation } from 'react-i18next';
import {
    Banner,
    BannerDescription,
    BannerEyebrow,
    BannerImage,
    BannerImageContainer,
    BannerLinks,
    BannerText,
    BannerTextContainer,
    BannerTitle,
    BoundedContent,
    Button,
    Column,
    FluidImage,
    GridContainer,
    Link,
    Row,
} from '@vp/swan';
import { sanitiseLocale } from '../../../../i18n/config';
import { useTrackNavigationClicked } from '../../../../utils/analytics';
import { logomakerCtaPathByLocale } from '../../../../utils/urls';

const FeatureBannerSimplePrompts = () => {
    const { t, i18n } = useTranslation();
    const locale = sanitiseLocale(i18n.language);

    const ctaRef = useTrackNavigationClicked(
        'Design Services',
        'Feature Banner Simple Prompts CTA',
        logomakerCtaPathByLocale(locale),
        'logoMaker',
    );

    return (
        <BoundedContent
            as="section"
            id="simple-prompts"
            py={{ xs: 4, md: 8 }}
            paddingX={{ xs: 0, sm: 3, md: 4, lg: 4, xl: 4 }}
        >
            <GridContainer>
                <Row style={{ justifyContent: 'center' }}>
                    <Column span={12} spanXl={10} spanLg={11} paddingX={{ xs: 0 }}>
                        <Banner backgroundColor="standard" textBoxHorizontalAlign="right">
                            <BannerImageContainer>
                                <BannerImage>
                                    <FluidImage
                                        src={t(
                                            'Logomaker GenAi Landing Page > Feature Banner Simple Prompts > Image.src',
                                        )}
                                        alt={t(
                                            'Logomaker GenAi Landing Page > Feature Banner Simple Prompts > Image > Alt Text.value',
                                        )}
                                    />
                                </BannerImage>
                            </BannerImageContainer>
                            <BannerTextContainer>
                                <BannerText textAlign="left">
                                    <BannerEyebrow>
                                        {t(
                                            'Logomaker GenAi Landing Page > Feature Banner Simple Prompts > Eyebrow.value',
                                        )}
                                    </BannerEyebrow>
                                    <BannerTitle as="h2" fontSkin="title-section">
                                        {t(
                                            'Logomaker GenAi Landing Page > Feature Banner Simple Prompts > Title.value',
                                        )}
                                    </BannerTitle>
                                    <BannerDescription as="p">
                                        {t(
                                            'Logomaker GenAi Landing Page > Feature Banner Simple Prompts > Description.value',
                                        )}
                                    </BannerDescription>
                                    <BannerLinks display={{ xs: 'none', sm: 'flex' }}>
                                        <Button
                                            skin="primary"
                                            render={(props) => (
                                                <Link
                                                    to={logomakerCtaPathByLocale(locale)}
                                                    className={props.className}
                                                    ref={ctaRef}
                                                >
                                                    {props.children}
                                                </Link>
                                            )}
                                        >
                                            {t(
                                                'Logomaker GenAi Landing Page > Feature Banner Simple Prompts > CTA Text.value',
                                            )}
                                        </Button>
                                    </BannerLinks>
                                </BannerText>
                            </BannerTextContainer>
                        </Banner>
                    </Column>
                </Row>
            </GridContainer>
        </BoundedContent>
    );
};

export default FeatureBannerSimplePrompts;
